import React, { useState } from 'react';
import { Search, Filter, X, ChevronDown } from 'lucide-react';
import Button from '../ui/Button';

const DiscountFilters = ({ 
  categories = [], 
  initialFilters = {},
  onFilterChange 
}) => {
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);
  const [filters, setFilters] = useState({
    searchQuery: initialFilters.searchQuery || '',
    categoryId: initialFilters.categoryId || '',
    type: initialFilters.type || '',
    sortBy: initialFilters.sortBy || 'newest',
    ...initialFilters
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onFilterChange(filters);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    onFilterChange(filters);
    setIsFiltersOpen(false);
  };

  const clearFilters = () => {
    const resetFilters = {
      searchQuery: '',
      categoryId: '',
      type: '',
      sortBy: 'newest'
    };
    setFilters(resetFilters);
    onFilterChange(resetFilters);
    setIsFiltersOpen(false);
  };

  return (
    <div className="bg-white shadow-sm rounded-lg p-4 mb-6">
      <form onSubmit={handleSearchSubmit} className="flex flex-col md:flex-row gap-4 items-center">
        <div className="relative flex-grow">
          <input
            type="text"
            name="searchQuery"
            value={filters.searchQuery}
            onChange={handleInputChange}
            placeholder="Пошук знижок..."
            className="w-full py-2 px-4 pl-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500"
          />
          <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
        </div>
        
        <div className="flex gap-2 self-end">
          <Button
            type="submit"
            variant="primary"
          >
            Пошук
          </Button>
          
          <Button
            type="button"
            variant="secondary"
            onClick={() => setIsFiltersOpen(!isFiltersOpen)}
            icon={isFiltersOpen ? <X size={18} /> : <Filter size={18} />}
          >
            Фільтри
          </Button>
        </div>
      </form>
      
      {isFiltersOpen && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <form onSubmit={handleFilterSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Категорія
              </label>
              <div className="relative">
                <select
                  name="categoryId"
                  value={filters.categoryId}
                  onChange={handleInputChange}
                  className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 appearance-none"
                >
                  <option value="">Всі категорії</option>
                  {categories.map(category => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-3 top-2.5 text-gray-400 pointer-events-none" size={18} />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Тип знижки
              </label>
              <div className="relative">
                <select
                  name="type"
                  value={filters.type}
                  onChange={handleInputChange}
                  className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 appearance-none"
                >
                  <option value="">Всі типи</option>
                  <option value="PERCENTAGE">Відсоткові</option>
                  <option value="FIXED">Фіксовані суми</option>
                  <option value="PROMOTIONAL">Акційні пропозиції</option>
                  <option value="COMBINED">Комбіновані</option>
                  <option value="SPECIAL_OFFER">Спеціальні пропозиції</option>
                </select>
                <ChevronDown className="absolute right-3 top-2.5 text-gray-400 pointer-events-none" size={18} />
              </div>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Сортування
              </label>
              <div className="relative">
                <select
                  name="sortBy"
                  value={filters.sortBy}
                  onChange={handleInputChange}
                  className="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 appearance-none"
                >
                  <option value="newest">Найновіші</option>
                  <option value="expiringSoon">Скоро закінчуються</option>
                  <option value="popular">Популярні</option>
                  <option value="percentageHighest">Найбільший відсоток</option>
                  <option value="valueHighest">Найбільша сума</option>
                </select>
                <ChevronDown className="absolute right-3 top-2.5 text-gray-400 pointer-events-none" size={18} />
              </div>
            </div>
            
            <div className="md:col-span-3 flex justify-end gap-2 mt-2">
              <Button
                type="button"
                variant="outline"
                onClick={clearFilters}
              >
                Скинути
              </Button>
              <Button type="submit" variant="primary">
                Застосувати
              </Button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default DiscountFilters;